import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchProductTypeAttributes } from '@/utils/shopCategoryApi';
const PRODUCT_TYPE_ATTRIBUTES_QUERY_KEY = ['productTypeAttributes'] as const;
export const useProductTypeAttributes = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: PRODUCT_TYPE_ATTRIBUTES_QUERY_KEY,
      queryFn: fetchProductTypeAttributes
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};